import { styled } from '../stitches.config';

export const ButtonGroup = styled('div', {
  [`& button:focus-visible`]: {
    position: 'relative',
    zIndex: 1,
  },

  [`& button:not(:first-of-type)`]: {
    borderLeftWidth: 0,
  },

  [`& button:not(:first-of-type):not(:last-of-type)`]: {
    borderRadius: 'unset',
  },

  [`& button:first-of-type:not(:last-of-type)`]: {
    borderTopRightRadius: 'unset',
    borderBottomRightRadius: 'unset',
  },

  [`& button:last-of-type:not(:first-of-type)`]: {
    borderTopLeftRadius: 'unset',
    borderBottomLeftRadius: 'unset',
  },
});
